// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the double circle icon.
 *
 * @component
 * @param {IconProps} props - The IconProps for the DoubleCircleIcon component.
 * @returns {ReactElement} The DoubleCircleIcon component.
 */
export const DoubleCircleIcon = (props: IconProps) => {
  const { color = '#C1C1CF', ...rest } = props;
  return (
    <Icon w='13px' h='13px' viewBox='0 0 13 13' color={color} {...rest}>
      <g id='End Point'>
        <circle id='Ellipse 160' cx='6.15381' cy='6.5' r='5.5' fill='white' stroke='#4F5DBA' />
        <circle id='Ellipse 159' cx='6.04443' cy='6.5' r='3.5' fill='#4F5DBA' stroke='white' />
      </g>
    </Icon>
  );
};
